export default __webpack_public_path__ + "static/media/logo_mochi.84cc1fd2.svg";